import type { AdminDTO } from '@/types/organization.dtos';
import type { AdminUser } from '@/types/organization.types';

/**
 * Map a single AdminDTO → AdminUser (app type)
 */
export function mapAdminDTOToAdmin(dto: AdminDTO): AdminUser {
  return {
    id: dto.id,
    name: dto.name,
    email: dto.email,
    phone: dto.phone,
    status: dto.status,
  };
}

/**
 * Map array of AdminDTOs → AdminUser[]
 */
export function mapAdminDTOsToAdmins(dtos: AdminDTO[]): AdminUser[] {
  return dtos.map(mapAdminDTOToAdmin);
}
